const tratamiento = [
  { id: "DON", text: "D" },
  { id: "DOÑA", text: "Dª" },
  { id: "OTRO", text: "Otro" },
  { id: "NO_CONTESTA", text: "Prefiero no contestar" },
];

export default tratamiento;
